import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class SliderAnimaux {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-animaux__swiper', {
      modules: [Pagination],
      direction: 'horizontal',
      slidesPerView: 1.1,
      spaceBetween: 24,
      grabCursor: true,
      preventInteractionOnTransition: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }, breakpoints: {
        768: {
          slidesPerView: 2.5,
        },
        1024: {
          slidesPerView: 3.5,
        },
      },
    });
  }
}

export const sliderAnimaux = new SliderAnimaux();
